(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kss-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.kssCookiePreferences) {
      window.kssCookiePreferences.refresh();
      return;
    }

    let bannerReady;

    const banner = () => {
      const api = window.privacyBanner;
      return api && typeof api.showPreferences === 'function' ? api : null;
    };

    const controls = () => Array.from(document.querySelectorAll('[data-kss-cookie-control]'));

    const showStatus = (visible) => {
      controls().forEach((control) => {
        const message = control.querySelector('[data-kss-cookie-error]');
        if (message) message.hidden = !visible;
      });
    };

    const exposeButtons = () => {
      const ready = Boolean(banner());
      controls().forEach((control) => {
        const button = control.querySelector('[data-kss-cookie-open]');
        if (button) button.hidden = !ready;
      });
      if (ready) showStatus(false);
      return ready;
    };

    const loadConsentApi = () => new Promise((resolve) => {
      if (window.Shopify?.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        resolve();
        return;
      }
      if (typeof window.Shopify?.loadFeatures !== 'function') {
        resolve();
        return;
      }
      const timeout = window.setTimeout(resolve, 4000);
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {
        window.clearTimeout(timeout);
        resolve();
      });
    });

    const loadBannerScript = () => new Promise((resolve, reject) => {
      if (banner()) {
        resolve(banner());
        return;
      }
      let script = document.querySelector('script[src*="/privacy-banner/storefront-banner.js"]');
      const created = !script;
      if (created) {
        script = document.createElement('script');
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.async = true;
      }
      let settled = false;
      let interval;
      let timeout;
      const finish = (error) => {
        if (settled) return;
        if (!error && !banner()) return;
        settled = true;
        window.clearInterval(interval);
        window.clearTimeout(timeout);
        if (error) reject(error);
        else resolve(banner());
      };
      script.addEventListener('load', () => finish(), { once: true });
      script.addEventListener('error', () => finish(new Error('privacy_banner_unavailable')), { once: true });
      interval = window.setInterval(() => finish(), 150);
      timeout = window.setTimeout(() => finish(new Error('privacy_banner_timeout')), 8000);
      if (created) document.head.appendChild(script);
      finish();
    });

    const ensureBanner = () => {
      if (banner()) return Promise.resolve(banner());
      if (!bannerReady) {
        bannerReady = loadConsentApi().then(loadBannerScript).catch((error) => {
          bannerReady = null;
          throw error;
        });
      }
      return bannerReady;
    };

    const refresh = () => {
      if (exposeButtons()) return;
      ensureBanner().then(exposeButtons).catch(() => showStatus(true));
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest?.('[data-kss-cookie-open]');
      if (!button) return;
      event.preventDefault();
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      showStatus(false);
      try {
        const api = await ensureBanner();
        await Promise.resolve(api.showPreferences());
      } catch {
        showStatus(true);
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });

    window.kssCookiePreferences = { refresh };
    document.addEventListener('visitorConsentCollected', exposeButtons);
    document.addEventListener('shopify:section:load', refresh);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
    else refresh();
    window.addEventListener('load', refresh, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
